import { RequestMethod, RequestHeader } from '../types';

export default class Request<TPayload> {
  private _method: RequestMethod;
  private _headers: RequestHeader[];
  private _payload: TPayload | null;

  public constructor(private _url: string) {
    this._method = 'GET';
    this._headers = [];
    this._payload = null;
  }

  public get url() {
    return this._url;
  }

  public get method() {
    return this._method;
  }

  public get headers() {
    return this._headers;
  }

  public get payload() {
    return this._payload;
  }

  public setMethod(method: RequestMethod) {
    this._method = method;
    return this;
  }

  public addHeader(header: RequestHeader) {
    const headerExisting = this._headers.find(
      headerCurrent => headerCurrent.name === header.name
    );
    if (headerExisting) {
      headerExisting.value = header.value;
    } else {
      this._headers.push(header);
    }
    return this;
  }

  public setPayload(payload: TPayload) {
    this._payload = payload;
    return this;
  }
}
